import { Component } from 'vue-property-decorator';
import EditorBase from './EditorBase';
import StreamContainer from '@/components/editor/StreamContainer.vue';
import VueDraggableResizable from 'vue-draggable-resizable';

@Component({
  components: {
    StreamContainer,
    VueDraggableResizable,
  },
})
export default class DraggableStreamContainer extends EditorBase {}
